import { useMemo } from "react";
import { Breadcrumbs, ClickAwayListener, Grow, Link, MenuItem, MenuList, Paper, Popper, Stack, TablePagination, Typography } from "@mui/material";
import { useFuncionariosTerceirizadoListaViewModel } from "../../viewModels/funcionarios_tercerizacao_lista_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GRID_CHECKBOX_SELECTION_FIELD, GridPinnedColumnFields } from "@mui/x-data-grid-pro";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { LegendaModal } from "./components/legenda_modal";
import { GenerateFuncionariosTercerizacaoColumns } from "./columns";
import { Header } from "./components/header";
import { AlterarInativoAtivoModal } from "./components/alterar_centro_custo";
import { useNavigate } from "react-router";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const FuncionariosTercerizacaoLista = () => {
  const viewModel = useFuncionariosTerceirizadoListaViewModel();
  const navigate = useNavigate();

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.funcionarios.length > 0 ?
      {
        left: [
          GRID_CHECKBOX_SELECTION_FIELD,
        ],
        right: [
          'IdFuncionarioTerc',
        ],
      } : {
      };
  }, [viewModel.funcionarios.length]);

  const FuncionariosTercerizacaoColumns = useMemo(() => {
    return GenerateFuncionariosTercerizacaoColumns({
      onActionEditar: viewModel.handleFuncionarioEdit,
      onActionDeletar: viewModel.handleDeleteModalOpenState
    });
  }, [viewModel.handleDeleteModalOpenState, viewModel.handleFuncionarioEdit]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[250px] ">
                <PrimaryButton
                  buttonColor="secondary"
                  onClick={() => viewModel.handleOpenInativoAtivoModal(true)}>
                  Inativa/Ativar selecionados
                </PrimaryButton>
              </div>

              <div>
                <Stack direction="row" spacing={2}>
                  <div className="w-[12rem]">
                    <PrimaryButton
                      ref={viewModel.menuRef}
                      id="composition-button"
                      aria-controls={viewModel.openMenu ? 'composition-menu' : undefined}
                      aria-expanded={viewModel.openMenu ? 'true' : undefined}
                      aria-haspopup="true"
                      onClick={viewModel.handleReportListaFuncionarios}
                      buttonColor="yellow">
                      Relatórios
                    </PrimaryButton>
                    <Popper
                      style={{ zIndex: 10000 }}
                      open={viewModel.openMenu}
                      anchorEl={viewModel.menuRef.current}
                      role={undefined}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === 'bottom-start' ? 'left top' : 'left bottom',
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={() => null}>
                              <MenuList
                                autoFocusItem={viewModel.openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={() => null}>
                                <MenuItem onClick={() => viewModel.handleReportsFuncionariosOpenState(true)}>Funcionários</MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>

              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />} onClick={() => navigate("/FuncionarioTercerizacao_cadastro/")}>
                  Novo Funcionário
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Terceirizado
          </Link>
          <Typography className="text-primary-green">
            Funcionários Terceirizado
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Funcionários Terceirizado </h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className="w-full justify-end flex gap-2">
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReloadPage} />
              </div>
            ) : (
              <>
                <Header
                  NomePesquisa={viewModel.filters.NomePesquisa}
                  FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
                  ContratoPesquisa={viewModel.filters.ContratoPesquisa}
                  StatusPesquisa={viewModel.filters.StatusPesquisa}
                  centroDeCusto={viewModel.filters.centroDeCusto}
                  centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
                  AvaliacoesPesquisa={viewModel.filters.AvaliacoesPesquisa}
                  CargoPesquisa={viewModel.filters.CargoPesquisa}
                  DocumentosPesquisa={viewModel.filters.DocumentosPesquisa}
                  handleCargoChange={viewModel.handleCargoChange}
                  handleDocumentosPesquisa={viewModel.handleDocumetosPesquisaChange}
                  handleAvaliacoesPesquisa={viewModel.handleAvaliacaoPesquisaChange}
                  onClearFilters={viewModel.handleClearFilters}
                  handleNomeCampoChange={viewModel.handleNomePesquisaChange}
                  handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
                  handleFornecedorChange={viewModel.handleFornecedorChange}
                  handleContratoChange={viewModel.handleContratoChange}
                  handleStatusPesquisa={viewModel.handleStatusPesquisaChange} />

                <Stack spacing={0}>
                  <div className="w-[180px] mb-10">
                    <span
                      className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
                      onClick={() => viewModel.handleShowLegenda(true)}>
                      Legenda
                    </span>
                  </div>


                  <StyledDataGrid
                    tableName="funcionarios_terceirizado _lista"
                    disableRowSelectionOnClick={true}
                    disableColumnMenu={false}
                    getRowId={(row) => row.IdFuncionarioTerc}
                    columns={FuncionariosTercerizacaoColumns}
                    loading={viewModel.loading}
                    checkboxSelection={true}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    rows={viewModel.funcionarios}
                    rowCount={viewModel.funcionarios.length}
                    pageSizeOptions={[10, 25, 50, 100]}
                    pinnedColumns={pinnedColumns}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    autoHeight={true}
                    textSize="medio"
                    getRowHeight={() => "auto"}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                </Stack>
              </>
            )
        }

        {/* Modals */}

        <LegendaModal
          open={viewModel.openLegendaModal}
          onClose={() => viewModel.handleShowLegenda(false)}
        />
        <AlterarInativoAtivoModal
          open={viewModel.alterarInativoAtivoModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleOpenInativoAtivoModal(false)}
          onSubmit={viewModel.handleAlterarInativoAtivoSubmit} />

        <DeleteDialog
          open={viewModel.deleteModal}
          saving={viewModel.saving}
          onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
          title={`Você realmente deseja excluir o funcionário ${viewModel.selectedFuncionario?.Nome}?`}
          onDelete={viewModel.handleDeleteConfirma} />


        {/* Relatorio */}
        <ReportViewerModal
          reportViewerState={viewModel.reportViewerState}
        />

      </div>
    </>
  );
}